import React, { useContext } from "react";

import { isEmpty, recoverTag, maskingMobile } from "bodycodi/cmap/app/js/common";
import { DispatchContext as HomeDispatchContext } from "bodycodi/cmap/app/components/cmap2010/home";
import { DispatchContext } from "bodycodi/cmap/app/components/common/context";
import empty from "bodycodi/cmap/app/img/member-profile-empty.png";
import icon_right_arrow_small from "bodycodi/cmap/app/svg/icon_right_arrow_small.svg";
import MemberType from "bodycodi/cmap/app/components/common/MemberType";

type ApMemberRpop = {
  ScheduleVO: any;
};

export const ApMember = ({ ScheduleVO }: ApMemberRpop) => {
  const { dispatch: homeDispatch } = useContext(HomeDispatchContext);
  const { dispatch } = useContext(DispatchContext);
  const src = isEmpty(ScheduleVO.imgUrl) ? empty : ScheduleVO.imgUrl;

  const clickMember = () => {
    homeDispatch({
      type: "UPDATE",
      data: {
        memberDtlPopData: {
          seqPartner: ScheduleVO.seqPartner,
          seqPartnerBranch: ScheduleVO.seqPartnerBranch,
          seqMember: ScheduleVO.seqMember,
        },
      },
    });
    dispatch({ type: "POP_UP_OPEN", id: "MEMBER_DTL_POP", open: { memberDtlPop: true } });
  };

  return (
    <div className="schedule-card ap">
      <div className="schedule-type">
        개인레슨
        {ScheduleVO.scheduleState === "R" && <span className="blue">예약</span>}
        {ScheduleVO.scheduleState === "S" && <span className="green1">출석요청중</span>}
        {ScheduleVO.scheduleState === "E" && <span className="green">출석</span>}
        {ScheduleVO.scheduleState === "A" && <span className="red">결석</span>}
        {ScheduleVO.scheduleState === "C" && <span className="red">취소</span>}
      </div>
      <div className="schedule-name">{recoverTag(ScheduleVO.scheduleName)}</div>
      <div className="schedule-partner">
        {ScheduleVO.partnerName} {ScheduleVO.partnerBranchName} &#183; {ScheduleVO.spaceName}
      </div>
      <div className="schedule-member" onClick={clickMember}>
        <img className="profile" src={src} />
        <div className="info">
          <div className="title">
            <div className="name">{ScheduleVO.name}</div>
            <MemberType
              appointmentMemberYn={ScheduleVO.appointmentMemberYn}
              chargeMemberYn={ScheduleVO.chargeMemberYn}
              isSmall
            />
          </div>
          {ScheduleVO.age === 0 ? (
            <div className="age">
              {maskingMobile(ScheduleVO.memberMobile)}
              <span className="no-age"> &#183; 나이 미설정</span>
            </div>
          ) : (
            <div className="age">
              {maskingMobile(ScheduleVO.memberMobile)} &#183; 만 {ScheduleVO.age}세
            </div>
          )}
        </div>
        <img src={icon_right_arrow_small} />
      </div>
    </div>
  );
};
